import { api } from './client';

export interface DelegationEmployee {
  id: string;
  firstName: string;
  lastName: string;
}

export interface Delegation {
  id: string;
  clientId: number;
  client: { id: number; name: string };
  fromEmployee: DelegationEmployee;
  toEmployee: DelegationEmployee;
  expiresAt: string;
  createdAt: string;
  wasAdjusted?: boolean;
  adjustedFrom?: string;
}

export interface AccessListItem {
  type: 'own' | 'subordinate' | 'delegated' | 'role' | 'additionalOffice';
  employee?: DelegationEmployee;
  role?: string;
  expiresAt?: string;
  via?: string;
  delegationId?: string; // ID делегирования для удаления
}

export interface ClientAccessInfo {
  client: { id: number; name: string };
  accessList: AccessListItem[];
  canManage: boolean;
}

export const delegationsApi = {
  // Создать делегирование
  create: async (data: {
    clientId: number;
    toEmployeeId: string;
    expiresAt: string;
  }): Promise<Delegation> => {
    const { data: result } = await api.post('/delegations', data);
    return result;
  },

  // Обновить делегирование (изменить срок)
  update: async (
    id: string,
    data: { expiresAt: string }
  ): Promise<Delegation> => {
    const { data: result } = await api.patch(`/delegations/${id}`, data);
    return result;
  },

  // Удалить делегирование
  remove: async (id: string): Promise<void> => {
    await api.delete(`/delegations/${id}`);
  },

  // Получить делегирования для клиента
  getForClient: async (clientId: number): Promise<Delegation[]> => {
    const { data } = await api.get(`/delegations/client/${clientId}`);
    return data;
  },

  // Получить информацию о доступе к клиенту
  getClientAccess: async (clientId: number): Promise<ClientAccessInfo> => {
    const { data } = await api.get(`/delegations/client/${clientId}/access`);
    return data;
  },
};
